import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import { FormsySelect } from 'formsy-material-ui/lib';
import { HOC } from 'formsy-react';
import { WeeksOfMonthPropTypes } from '../../../../enums/weeksOfMonth';
import globals from '../../../../globals/communityGlobals';
import { dropDownStyle, common } from '../../../../theme/AllocateBaseTheme';
import { DaysOfWeekPropTypes } from '../../../../enums/daysOfWeek';

const locale = globals.getAreas(['treatments', 'error']);

class WeekOfMonthOption extends Component {
  handleSelect = (event, key) => {
    this.props.setValue([key]);
  };
  generateMenuItems = options => {
    let menuItems = [];
    menuItems = Object.keys(options).map(key => <MenuItem key={key} primaryText={options[key]} value={key} />);

    return menuItems;
  };

  render() {
    const { getValue, name, options } = this.props;
    const value = getValue();
    const valueKeysArray = value ? [...value] : [];
    return (
      <FormsySelect
        key={name}
        required
        requiredError={locale.getMsg('requiredFieldValidationMessage')}
        name={'selected'}
        floatingLabelText={`${locale.getMsg(name)}*`}
        value={valueKeysArray[0]}
        onChange={this.handleSelect}
        floatingLabelStyle={common.floatingLabelStyle}
        floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
        floatingLabelFocusStyle={common.floatingLabelFocusStyle}
        underlineStyle={common.underlineStyle}
        style={dropDownStyle.style}
        errorStyle={common.errorStyle}
        iconStyle={dropDownStyle.iconStyle}
        labelStyle={dropDownStyle.labelStyle}
        menuStyle={dropDownStyle.menuStyle}
      >
        {this.generateMenuItems(options)}
      </FormsySelect>
    );
  }
}

WeekOfMonthOption.defaultProps = {
  disabled: false,
};

WeekOfMonthOption.propTypes = {
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([WeeksOfMonthPropTypes, DaysOfWeekPropTypes]).isRequired,
};

export default HOC(WeekOfMonthOption);
